import Login from "./Login";
import Dashboard from "../Dashboard/Dashboard";
import AdminBooking from "../AdminBooking/AdminBooking";
import DisableDays from "../DisableDays/DisableDays";
import Logs from "../Logs/Logs";
import AllAppointments from "../AllAppointments/AllAppointments";
import Menu from "../Menu/Menu";
import WeeklySchedule from "../WeeklySchedule/WeeklySchedule";
import Settings from "../Settings/Settings";

export const ROUTES = [
  {
    component: Login,
    isPublic: true,
    isProtected: false,
    path: "/login",
    slug: "login",
    title: "Sign in",
    redirectTo: "/dashboard",
    useShell: false,
  },
  {
    component: Dashboard,
    isPublic: false,
    isProtected: true,
    path: "/dashboard",
    slug: "dashboard",
    title: "Home",
    redirectTo: "/login",
    useShell: true,
  },
  {
    component: AdminBooking,
    isPublic: false,
    isProtected: true,
    path: "/admin-booking",
    slug: "Admin Booking",
    title: "Book",
    redirectTo: "/login",
    useShell: true,
  },
  {
    component: AllAppointments,
    isPublic: false,
    isProtected: true,
    path: "/appointments",
    slug: "All Appointments",
    title: "List",
    redirectTo: "/login",
    useShell: true,
  },
  {
    component: DisableDays,
    isPublic: false,
    isProtected: true,
    path: "/disable-dates",
    slug: "Disable Days",
    title: "Disable Days",
    redirectTo: "/login",
    useShell: true,
  },
  {
    component: Logs,
    isPublic: false,
    isProtected: true,
    path: "/logs",
    slug: "Logs",
    title: "WhatsApp Logs",
    redirectTo: "/login",
    useShell: true,
  },
  {
    component: WeeklySchedule,
    isPublic: false,
    isProtected: true,
    path: "/weekly-schedule",
    slug: "Weekly Schedule",
    title: "Weekly Schedule",
    redirectTo: "/login",
    useShell: true,
  },
  {
    component: Settings,
    isPublic: false,
    isProtected: true,
    path: "/settings",
    slug: "Settings",
    title: "Settings",
    redirectTo: "/login",
    useShell: true,
  },
  {
    component: Menu,
    isPublic: false,
    isProtected: true,
    path: "/menu",
    slug: "Menu",
    title: "More",
    redirectTo: "/login",
    useShell: true,
  },
];

export function getRouteTitle(pathname: string): string {
  return ROUTES.find((r) => r.path === pathname)?.title ?? "Admin Panel";
}
